module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/share-ai-dc3e0664388d63b54d04673b2cbd7221.png";